(() => {
  let widgetObserver;

  const setImportant = (element, property, value) => {
    if (element.style.getPropertyValue(property) === value && element.style.getPropertyPriority(property) === 'important') {
      return;
    }

    element.style.setProperty(property, value, 'important');
  };

  const positionWidget = () => {
    const widget = document.getElementById('zeik0-widget-container');
    if (!widget?.querySelector('#zeik0-widget-iframe')) return false;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const pageType = document.getElementById('MainContent')?.dataset.template;

    if (!widgetObserver) {
      widgetObserver = new MutationObserver(positionWidget);
      widgetObserver.observe(widget, { attributes: true, attributeFilter: ['style'] });
    }

    if (isMobile && pageType === 'cart') {
      setImportant(widget, 'display', 'none');
      return true;
    }

    widget.style.removeProperty('display');
    if (isMobile && pageType === 'product') {
      setImportant(widget, 'inset', 'auto 0px 8.2rem auto');
    } else if (isMobile) {
      setImportant(widget, 'inset', 'auto 0px 0.8rem auto');
    }

    return true;
  };

  const observer = new MutationObserver(() => {
    if (!positionWidget()) return;
    observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  positionWidget();
  window.addEventListener('resize', positionWidget);
})();
